<template>
  <span>
    <v-btn
      icon
      color="blue darken-2"
      :disabled="!this.value.borrable"
      @click="showDialogDocumentTypeUpdate"
    >
      <v-icon>{{ icon.pencil }}</v-icon>
    </v-btn>

    <component
      :is="dialogForm"
      v-model="documentType"
      @onUpdate="close"
      @onClose="close"
    />
  </span>
</template>

<script>
import { mdiPencilOutline } from '@mdi/js'
import DocumentTypeDialogForm from '@/modules/catalogs/components/DocumentTypeDialogForm'

export default {
  name: 'DocumentTypeUpdate',
  components: {
    DocumentTypeDialogForm
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      icon: {
        pencil: mdiPencilOutline
      },
      dialogForm: ''
    }
  },
  computed: {
    documentType() {
      return {
        idTipoDocumento: this.value.idTipoDocumento,
        clave: this.value.clave,
        nombre: this.value.nombre
      }
    }
  },
  methods: {
    showDialogDocumentTypeUpdate() {
      this.dialogForm = 'DocumentTypeDialogForm'
    },
    close() {
      this.dialogForm = ''
    }
  }
}
</script>
